import React from 'react';
import CategoryTiles from '@hpstellar/core/CategoryTiles';

import withPageComponents from '../../../page/components/with-page-components';

const homeBanner = ({ homeBanner }) => {
    const { homeBanner: homeTiles } = homeBanner || {};
    if (homeTiles && homeTiles.length > 0) {
        return (<CategoryTiles
            categoryTiles={homeTiles}
            orientation="horizontal"
            size="small"
            variation="noImage"
        />);
    }
    return null;
}

export default withPageComponents(homeBanner, { components: ['homeBanner'] })

